import { useEffect, useRef, useState } from 'react'

/**
 * Save-as-you-go for every step of the submit flow. Debounced, and it skips the
 * first render so opening a step doesn't write a no-op.
 */
export function useAutosave(value, save, delay = 700) {
  const [state, setState] = useState('idle') // idle | saving | saved | error
  const first = useRef(true)
  const latest = useRef(save)
  latest.current = save

  useEffect(() => {
    if (first.current) { first.current = false; return }
    setState('saving')
    const t = setTimeout(async () => {
      try {
        await latest.current(value)
        setState('saved')
      } catch {
        setState('error')
      }
    }, delay)
    return () => clearTimeout(t)
  }, [JSON.stringify(value), delay]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}
